module.exports = __webpack_public_path__ + "blog-header.jpg?d0397a1e060329403a433da30e735270";